import * as React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Provider } from "react-redux";

import { MainScreen } from "../containers";
import { TPTurquoise, White } from "../../shared/common-design/colors";
import { AnyAction, Store } from "redux";

export const theme = createTheme({
    typography: {
        fontFamily: "PF Din",
        h6: {
            color: White,
            fontSize: "5vh"
        }
    },
    components: {
        MuiBackdrop: {
            styleOverrides: {
                root: {
                    backgroundColor: `rgba(${White}, 0.541176)`
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    color: White,
                    fontSize: "3em"
                }
            }
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    backgroundColor: TPTurquoise
                },
            },
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    justifyContent: "center"
                },
            },
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    color: White,
                    fontSize: "5vh"
                },
            },
        },
    },
});

export const DesktopApplication = ({ store }: { store: Store<unknown, AnyAction> }): JSX.Element => {

    return (
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <MainScreen />
            </ThemeProvider>
        </Provider>
    );
};
